import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_700, Checkbox, Divider, isLastItem, LILAC_400, Typography, WHITE } from '@airtel/air-design-system';
import { Fragment } from 'react';
import { View } from 'react-native';
import { KeyPairUnitWidget } from '../../../key-pair-unit-widget';
import { getLineChartLegendStyles } from './LineChartLegendsStyle';
export var LineChartLegend = props => {
  var _a;
  var chartData = props.chartData,
    setChartData = props.setChartData,
    keyPairUnitWidgetPropsList = props.keyPairUnitWidgetPropsList,
    graphData = props.graphData;
  var lineChartLegendStyle = getLineChartLegendStyles(props);
  var toggleDataVisibility = _ref => {
    var label = _ref.label;
    var _a;
    var data = {
      chartData: Object.assign(Object.assign({}, chartData), {
        datasets: [...[(_a = chartData === null || chartData === void 0 ? void 0 : chartData.datasets) === null || _a === void 0 ? void 0 : _a.map(dataset => {
          if (dataset.label === label) {
            dataset.hidden = !dataset.hidden;
          }
          return dataset;
        })]]
      })
    };
    setChartData(data);
  };
  var Legend = _ref2 => {
    var legendLabel = _ref2.legendLabel,
      data = _ref2.data,
      index = _ref2.index;
    var _a, _b, _c, _d, _e;
    var isDataVisible = !!((_a = data === null || data === void 0 ? void 0 : data.datasets) === null || _a === void 0 ? void 0 : _a.find(_ref3 => {
      var label = _ref3.label;
      return label === legendLabel;
    }).hidden);
    return _jsxs(View, Object.assign({
      style: lineChartLegendStyle.container
    }, {
      children: [_jsx(Checkbox, {
        checked: !isDataVisible,
        label: legendLabel,
        style: lineChartLegendStyle.checkbox,
        onPress: () => {
          toggleDataVisibility({
            label: legendLabel
          });
        },
        checkboxBgColor: !isDataVisible ? (_c = (_b = data === null || data === void 0 ? void 0 : data.datasets) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.borderColor : WHITE,
        checkboxBorderColor: (_e = (_d = data === null || data === void 0 ? void 0 : data.datasets) === null || _d === void 0 ? void 0 : _d[index]) === null || _e === void 0 ? void 0 : _e.borderColor
      }), _jsx(KeyPairUnitWidget, Object.assign({
        showDivider: true,
        valueAsBold: false
      }, keyPairUnitWidgetPropsList === null || keyPairUnitWidgetPropsList === void 0 ? void 0 : keyPairUnitWidgetPropsList[index], {
        style: {
          flexWrap: 'nowrap'
        }
      }))]
    }));
  };
  return _jsxs(Fragment, {
    children: [_jsx(Divider, {
      height: 2,
      color: LILAC_400,
      shadowColor: WHITE,
      style: {
        marginVertical: 12
      }
    }), (graphData === null || graphData === void 0 ? void 0 : graphData.legendTitle) && _jsx(Typography, {
      text: graphData === null || graphData === void 0 ? void 0 : graphData.legendTitle,
      type: "title-single-line-lg",
      color: BLACK_700
    }), _jsx(View, Object.assign({
      style: [lineChartLegendStyle.legendContainer]
    }, {
      children: (_a = chartData === null || chartData === void 0 ? void 0 : chartData.datasets) === null || _a === void 0 ? void 0 : _a.map((dataset, index) => {
        return _jsxs(Fragment, {
          children: [_jsx(Legend, Object.assign({}, {
            legendLabel: dataset === null || dataset === void 0 ? void 0 : dataset.label,
            data: chartData
          }, {
            index: index
          })), !isLastItem(chartData === null || chartData === void 0 ? void 0 : chartData.datasets, index) && _jsx(Divider, {
            isVertical: true,
            height: 2,
            color: "#E3E5FF",
            shadowColor: "#FFFFFF",
            style: {
              marginHorizontal: 24
            }
          })]
        }, "legend-" + index);
      })
    }))]
  });
};